import { all, call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import { transformRequestOptions } from "utils/queryString";
import api from "_config/api";

import {
  getUsersPaginated,
  getUsersPaginatedFailed,
  getUsersPaginatedSuccess, GetUsersRequest,
  GetUsersResponse
} from "./actions/getUsersPaginated";

import { getRoles, getRolesFailed, getRolesSuccess } from "./actions/getRoles";

import { forgotPasswordFailed, ForgotPasswordRequest, forgotPasswordRequest, forgotPasswordSuccess } from "store/modules/users/actions/forgotPassword";
import { registerUserFailed, registerUserRequest, RegisterUserRequest, registerUserSuccess } from "store/modules/users/actions/registerUser";
import { resetPasswordFailed, ResetPasswordRequest, resetPasswordRequest, resetPasswordSuccess } from "store/modules/users/actions/resetPassword";
import { removeMasks } from "utils/remove-masks";
import {
  linkerRole, linkerRoleFailed,
  LinkerRoleRequest, linkerRoleSuccess
} from "./actions/linkerRole";

function* getListUsers(params: { type: string; payload: GetUsersRequest }) {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `/usuario`,
      {
        params: params.payload,
        paramsSerializer: (params) => transformRequestOptions(params),
      }
    );
    const { data }: { data: GetUsersResponse } = response;

    yield put(getUsersPaginatedSuccess(data));
  } catch (error) {
    yield put(getUsersPaginatedFailed(formatError(error)));
  }
}

function* getListRoles() {
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `/auth/roles`
    );
    const { data } = response;

    yield put(getRolesSuccess(data));
  } catch (error) {
    yield put(getRolesFailed(formatError(error)));
  }
}

function* linker(params: { type: string; payload: LinkerRoleRequest }) {
  const { onSuccess, idUsuario, ...role } = params.payload;
  try {
    yield call(api.put, `/auth/${idUsuario}/roles`, role);
    yield put(linkerRoleSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(linkerRoleFailed(formatError(error)));
  }
}

function* registerUser(params: { type: string; payload: RegisterUserRequest }) {
  const { onSuccess, user, onFailed } = params.payload;
  try {
    yield call(api.post, `/auth/register`, user);
    yield put(registerUserSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(registerUserFailed(formatError(error)));
    if (onFailed) onFailed();
  }
}

function* forgotPassword(params: { type: string; payload: ForgotPasswordRequest }) {
  const { onSuccess, cpf, onFailed } = params.payload;
  try {
    yield call(api.post, `/auth/resetPassword`, { cpf: removeMasks(cpf) });
    yield put(forgotPasswordSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(forgotPasswordFailed(formatError(error)));
    if (onFailed) onFailed();
  }
}

function* resetPassword(params: { type: string; payload: ResetPasswordRequest }) {
  const { onSuccess, idUsuario, token, newPassword, onFailed } = params.payload;
  try {
    yield call(api.put, `/auth/${idUsuario}/updatePassword`, { newPassword }, { params: { token } });
    yield put(resetPasswordSuccess());
    if (onSuccess) onSuccess();
  } catch (error) {
    yield put(resetPasswordFailed(formatError(error)));
    if (onFailed) onFailed();
  }
}

export default all([
  takeLatest(getUsersPaginated.type, getListUsers),
  takeLatest(getRoles.type, getListRoles),
  takeLatest(linkerRole.type, linker),
  takeLatest(registerUserRequest.type, registerUser),
  takeLatest(resetPasswordRequest.type, resetPassword),
  takeLatest(forgotPasswordRequest.type, forgotPassword),
]);
